import React, { useEffect, useState } from "react";
import { DEFAULT_BATCH_YEAR, BATCH_OPTIONS, SUBJECTS_ENUM } from "../../config";
import SnackbarComponent from "../Common/SnackbarComponent";
import Banner from "../Common/Banner";
import Loader from "../Common/Loader";
import Graph from "../AdminDashboard/Graph";
import api from "../Auth/Middleware";
import MarksTable from "./MarksTable";
import { formatDate } from "../../utils";
import MyInfoCard from "./MyInfoCard";
import SubjectTabs from "./SubjectTabs";
import RankCard from "./RankCard";
import { useParams } from "react-router-dom";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const intialInfo = {
  studentName: "",
  studentClass: "",
  fatherName: "",
  contact: "",
  school: "",
  address: "",
  dob: "",
};

function StudentDashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [snackbarMsg, setSnackbarMSg] = useState("");
  const [snackbarSevierty, setSnackbarSevierty] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [testBarData, setTestBarData] = useState(null);
  const [testData, setTestData] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState("Maths");
  const [rank, setRank] = useState(0);
  const [myInfo, setMyInfo] = useState(intialInfo);
  const [currentClass, setCurrentClass] = useState(null);
  const [studentId, setStudentId] = useState(null);
  const role = sessionStorage.getItem("role");
  const [batch, setBatch] = useState(
    role === "Admin"
      ? (parseInt(sessionStorage.getItem("selectedBatch")) || DEFAULT_BATCH_YEAR)
      : DEFAULT_BATCH_YEAR
  );
  const {id} = useParams();

  const handleBatchChange = (e) => {
    setBatch(e.target.value);
    sessionStorage.setItem("selectedBatch", e.target.value);
  };

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    setIsTableLoading(true);
    if (currentClass && studentId) {
      const fetchData = async () => {
        try {
          const response = await api.get(
            `Student/GetTestDetailsForStudent?studentId=${studentId}&class=${currentClass}&course=${SUBJECTS_ENUM[selectedSubject]}&batch=${batch}`
          );
          await handleBarData(response?.data?.marksDetails);
          handleMarksTableData(response?.data?.marksDetails);
          setIsTableLoading(false);
        } catch (error) {
          setIsTableLoading(false);
          setSnackbarOpen(true);
          setSnackbarMSg(error.message);
          setSnackbarSevierty("error");
        }
      };
      fetchData();
    }
  }, [selectedSubject, currentClass, studentId, batch]);

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        let apiUrl = `Student/GetPersonalInfo`;
        const role = sessionStorage.getItem("role");
        if(role && role !== 'Student'){
          apiUrl= `Student/GetPersonalInfo?studentId=${id}`
        }
        const response = await api.get(apiUrl);
        handleMyInfo(response?.data);
        setCurrentClass(response?.data.class);
        setStudentId(response?.data.id);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setSnackbarOpen(true);
        setSnackbarMSg(error.message);
        setSnackbarSevierty("error");
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBarData = (data) => {
    const sortedData = data?.sort(
      (a, b) => new Date(a.dateofExam) - new Date(b.dateofExam)
    );
    const transformedArray = sortedData?.map((obj) => ({
      month: formatDate(new Date(obj.dateofExam)),
      yValue: (obj.marks * 100) / obj.maxMarks,
    }));
    setTestBarData(transformedArray);
  };

  const handleMarksTableData = (data) => {
    const sortedData = data?.sort(
      (a, b) => new Date(b.dateofExam) - new Date(a.dateofExam)
    );
    setRank(sortedData ? sortedData[0]?.rank : "0");
    setTestData(sortedData);
  };

  const handleSubjectChange = (selectedSubject) => {
    // Update the state or perform filtering logic here
    setSelectedSubject(selectedSubject);
  };

  const handleMyInfo = (data) => {
    myInfo.studentName = data.name;
    myInfo.fatherName = data.fatherName;
    myInfo.address = data.address;
    myInfo.contact = data.studentContact;
    myInfo.dob = formatDate(new Date(data.dateOfBirth));
    myInfo.school = data.school;
    const nextDueParsed = data.nextDue ? new Date(data.nextDue) : null;
    myInfo.nextDue = nextDueParsed && nextDueParsed.getFullYear() > 1
      ? formatDate(nextDueParsed)
      : "Not set";
    myInfo.studentClass = data.class;
    setMyInfo(myInfo);
  };

  return (
    <>
      <SnackbarComponent
        open={snackbarOpen}
        severity={snackbarSevierty}
        message={snackbarMsg}
        onClose={closeSnackbar}
      ></SnackbarComponent>
      <Banner title="Student Dashboard" currentpage="Student Dashboard" />
      <div className="container">
        {role === "Admin" && (
          <div className="mt-4">
            <FormControl fullWidth>
              <InputLabel id="batch-select-label">Select Batch</InputLabel>
              <Select
                labelId="batch-select-label"
                value={batch}
                onChange={handleBatchChange}
                label="Select Batch"
              >
                {BATCH_OPTIONS.map((b) => (
                  <MenuItem key={b} value={b}>{b}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}
        <div className="row">
          <div className="col-md-6 col-sm-12 my-5">
            {isLoading ? <Loader /> : <MyInfoCard {...myInfo} />}
          </div>
          <div className="col-md-6 col-sm-12">
            {isLoading ? <Loader /> : <RankCard rank={rank} subject={selectedSubject} />}
          </div>
        </div>
        <div className="row my-1">
          <div className="col-md-12 col-sm-12">
            <div className="mb-2">
              <SubjectTabs onFilterChange={handleSubjectChange} standard={currentClass} />
            </div>
            {isTableLoading ? (
              <div className="text-center">
                {" "}
                <Loader className="ml-2" />{" "}
              </div>
            ) : testData ? (
              <MarksTable data={testData} />
            ) : (
              <p className="my-5 mx-auto py-5 px-5 border border-2">
                No Marks Available
              </p>
            )}
          </div>
        </div>
        <div className="col-md-12 col-sm-12">
          {isLoading ? (
            <Loader />
          ) : (
            testBarData && (
              <Graph
                data={testBarData}
                label={"Percentage Obtained"}
                xlabel={"Percentage"}
                yLabel={"Dates"}
              />
            )
          )}
        </div>
      </div>
    </>
  );
}

export default StudentDashboard;
